/**
 * Current process status id for the Change DBA Status modal.
 * List rows often expose status via `last_status_log` / `lastStatusLog` while `dba.status` may be absent.
 */
export function getDbaProcessStatusId(dba) {
  if (!dba) return '';
  const id =
    dba.status?.id ??
    dba.process_status?.id ??
    dba.last_status_log?.status?.id ??
    dba.lastStatusLog?.status?.id;
  if (id === undefined || id === null) return '';
  return id;
}
